<template lang="jade">
  .container-fluid
    .row
      .status_main.col-md-12
        header.status_title_bar.main_title_bar.clearfix
          h1.title.col-lg-10.col-md-10.col-sm-10.col-xs-10 status
        section.status_content
          section.in_screen_section
            h2 input
            .col-lg-4.col-md-5.col-sm-6.col-xs-12
              in-screen
          //- section.out_screen_section
            h2 output
            .col-lg-4.col-md-5.col-sm-6.col-xs-12
              out-screen
</template>
<script>
import inScreen from 'src/components/Input-Screen.vue'
import outScreen from 'src/components/Output-Screen.vue'
import { call } from 'src/Service.js'
import store from 'src/vuex/videoStore'

export default {
  components: {
    'in-screen': inScreen,
    'out-screen': outScreen
  },
  data () {
    return {
      outResolutionOptions: []
    }
  },
  asyncData () {
    let { mac } = this.$route.params
    call(mac, 'dxGetInputResolution').then(({resolution}) => {
      store.commit('UPDATE', {
        type: 'inResolution',
        resolution
      })
      return call(mac, 'dxGetOutputResolution')
    })
    .then(({resolution}) => {
      store.commit('UPDATE', {
        type: 'outResolution',
        resolution
      })
      return call(mac, 'dxGetOutputResolutionOptions')
    })
    .then(({options}) => {
      this.outResolutionOptions = options
      return call(mac, 'dxGetSplitArea')
    })
    .then(({setting}) => {
      store.commit('UPDATE', {
        type: 'split',
        splitArea: setting
      })
      store.commit('UPDATE', {
        type: 'outRatio'
      })
      store.commit('UPDATE', {
        type: 'inRatio'
      })
    })
    .catch(err => {
      console.log(err)
    })
  },
  computed: {

  },
  methods: {

  }, // close methods
  ready () {

  },
  watch: {
  },
  route: { // add these code to index of every type of devices to reload data
    canReuse: false, // can't reuse so forces it to reload data
    activate ({next}) {
      next()
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~__vendor_variables_scss__';
@import '~sass/_breakpoint.scss';

</style>



// WEBPACK FOOTER //
// Status.vue?5e57dfb8